import { useLocation, useNavigate } from 'react-router-dom';

interface CategorySwitcherProps {
  variant?: 'desktop' | 'mobile';
}

const categories = [
  { path: '/gostilna', short: 'GOSTILNA', full: 'GOSTILNA' },
  { path: '/sobe', short: 'SOBE', full: 'SOBE IN PRENOČIŠČA' },
];

export default function CategorySwitcher({ variant = 'desktop' }: CategorySwitcherProps) {
  const location = useLocation();
  const navigate = useNavigate();
  const isRooms = location.pathname.startsWith('/sobe');
  const isLarge = variant === 'mobile';

  const go = (path: string) => {
    const alreadyActive = path === '/sobe' ? isRooms : !isRooms;
    if (alreadyActive) return;
    navigate(path);
    window.scrollTo({ top: 0 });
  };

  return (
    <div
      className={`inline-flex items-center rounded-full border border-white/15 bg-white/5 ${
        isLarge ? 'p-1.5' : 'p-1'
      }`}
    >
      {categories.map((cat) => {
        const active = cat.path === '/sobe' ? isRooms : !isRooms;
        return (
          <button
            key={cat.path}
            onClick={() => go(cat.path)}
            aria-label={cat.full}
            className={`rounded-full font-label font-semibold tracking-wide transition-all duration-300 whitespace-nowrap cursor-pointer ${
              isLarge ? 'px-6 py-2.5 text-sm' : 'px-4 py-1.5 text-[11px]'
            } ${
              active
                ? 'bg-primary-500 text-background-950'
                : 'text-white/70 hover:text-white hover:bg-white/5'
            }`}
          >
            {isLarge ? cat.full : cat.short}
          </button>
        );
      })}
    </div>
  );
}